import React from "react";
import { Grid } from '@mui/material';
import { SearchBox } from "../../components/SearchBox";

export const SearchBar = ({setFilterString, placeholder="Search by Name" }) => {
    
    const handleSearch = (searchTerm: string) => {
        setFilterString(searchTerm);
    };

    return (
        <Grid sx={{ display: 'flex', justifyContent: 'end', width: '100%' }  }>
            <Grid sx={{ width: '40vw', minWidth: '300px', maxWidth: '500px' }}> {/* Adjust width value as needed */}
                <SearchBox 
                    onChange={(e) => handleSearch(e)}
                    onBlur={(e) => handleSearch(e)}
                    placeholder={placeholder} 
                />
            </Grid>
        </Grid>
    );
}